module.exports = __webpack_public_path__ + "img/icon67.c6850e38.png";